import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'
import _ from 'common-tools/LodashHelper'

class ViewBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string
  })

  render () {
    const { type, formatter, SessionToken, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, style, name, placeHolder, loading }) =>
          value !== undefined && value !== '' ? <img style={style}
            name={`view${name}`}
            id={`view${name}`}
            value={_.isFunction(formatter) ? formatter(value) : value}
            src={`/Files/Get/${value}/?token=${SessionToken}`} /> : null}
      </FieldLayoutBox>
    )
  }
};

export const PictureViewBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={ViewBoxClass} /> } // eslint-disable-line
export default PictureViewBox
